/* ─────────────────────────────────────────────────────────────────────────────
 *  doodles.ts — Google Doodle date configurations
 * ───────────────────────────────────────────────────────────────────────────── */

export interface DoodleConfig {
  month: number; // 1-12
  day: number;
  label: string;
  animation: "bounce" | "spin" | "shake" | "glow";
  emoji?: string;
}

const DOODLES: DoodleConfig[] = [
  { month: 1, day: 1, label: "Happy New Year!", animation: "bounce", emoji: "🎉" },
  { month: 2, day: 14, label: "Happy Valentine's Day!", animation: "glow", emoji: "❤️" },
  { month: 3, day: 17, label: "Happy St. Patrick's Day!", animation: "shake", emoji: "☘️" },
  { month: 7, day: 4, label: "Happy 4th of July!", animation: "bounce", emoji: "🎆" },
  { month: 10, day: 31, label: "Happy Halloween!", animation: "shake", emoji: "🎃" },
  { month: 12, day: 25, label: "Merry Christmas!", animation: "glow", emoji: "🎄" },
  { month: 12, day: 31, label: "Happy New Year's Eve!", animation: "spin", emoji: "✨" },
];

export function getTodaysDoodle(): DoodleConfig | undefined {
  const now = new Date();
  const month = now.getMonth() + 1;
  const day = now.getDate();
  return DOODLES.find((d) => d.month === month && d.day === day);
}
